<template>
	<div class="vehbusiness" v-loading.fullscreen.lock="visible.loading"
		element-loading-background="rgba(0, 0, 0, 0.4)">
		<div class="crumbs">
			<el-breadcrumb separator="/">
				<el-breadcrumb-item><i class="icon-lx-calendar"></i> 门禁业务</el-breadcrumb-item>
				<el-breadcrumb-item>卡片业务</el-breadcrumb-item>
			</el-breadcrumb>
		</div>

		<div class="container">
			<el-row>
				<el-col :span="5">
					<div class="handle-box">
						<el-input placeholder="单位名称" suffix-icon="el-icon-search"
							v-model.lazy="data.search.filterdeptstr" @change="filterDept" size="large" clearable>
							<el-checkbox slot="prepend" v-model="data.containSubVehicle"
								@change="changeContainSubVehicle">包含下级</el-checkbox>
						</el-input>
					</div>
					<div style="max-height:600px;overflow:auto;">
						<el-tree ref="depts" :data="data.depts" node-key="id" :check-on-click-node="true"
							highlight-current :expand-on-click-node="false" @node-click="handleDeptNodeClick"
							:filter-node-method="handleTreeFilter">
							<span class="span-ellipsis" slot-scope="{ node, data }">
								<span :title="node.label">{{ node.label }}</span>
							</span>
						</el-tree>
					</div>
				</el-col>
				<el-col :span="1">
					&nbsp;
				</el-col>
				<el-col :span="18">
					<div class="handle-box">
						<el-input v-model="data.search.filterstr" placeholder="车牌号" size="large" style="width:350px;"
							@change="search(true)">
							<el-button slot="append" type="primary" icon="if-lcon-duqushenfenzheng"
								@click="readFromIdCardReader"></el-button>
						</el-input>
						<el-button class="ml10" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
					</div>
					<div class="handle-box">
						<!--<el-button class="ml10" type="primary" icon="if-lcon-daoru" @click="toImport"
							v-if="power.import">导入车辆
						</el-button>-->
						<el-button class="ml10" type="primary" icon="if-lcon-xinxibiangeng" @click="toChangeInfo"
							v-if="power.changeinfo" :disabled="data.selections.length != 1">信息变更
						</el-button>
						<el-button class="ml10" type="primary" icon="if-lcon-faka" @click="toChangeRight"
							v-if="power.changeright" :disabled="data.selections.length == 0">权限变更
						</el-button>
						<el-button class="ml10" type="primary" icon="if-lcon-zhuxiaorenyuan" @click="toCancel"
							v-if="power.cancel" :disabled="data.selections.length == 0">注销
						</el-button>
					</div>

					<el-table ref="table" :data="data.rows" border class="table" row-key="id" highlight-current-row
						@current-change="tableCurrentChange" @selection-change="handleSelectionChange"
						@cell-click="handleCellClick">
						<el-table-column type="selection"></el-table-column>
						<el-table-column prop="headImage" label="照片" width="80">
							<template slot-scope="scope">
								<el-image style="height:50px;" :src="scope.row.carImage"
									:preview-src-list="[scope.row.carImage]"></el-image>
							</template>
						</el-table-column>
						<el-table-column prop="licensePlate" label="车牌号" width="140">
						</el-table-column>
						<el-table-column prop="deptName" label="单位" width="200" show-overflow-tooltip>
						</el-table-column>
						<el-table-column prop="checkDate" label="车检有效期" width="150">
						</el-table-column>
						<el-table-column prop="validDate" label="审核有效期" width="150">
						</el-table-column>
						<el-table-column prop="needCard" label="是否刷卡" width="120">
						</el-table-column>
						<el-table-column prop="driStatus" label="司机状态" width="200">
						</el-table-column>
						<el-table-column prop="crTime" label="创建时间" width="280">
						</el-table-column>
					</el-table>
					<div class="pagination">
						<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentPageChange"
							:current-page="data.page" :page-sizes="[10,20,50,100,200,300,400,500,1000,2000]"
							:page-size="data.size" layout="total, sizes, prev, pager, next, jumper" :total="data.total">
						</el-pagination>
					</div>
				</el-col>
			</el-row>
		</div>

		<!--<el-dialog title="导入车辆信息" :visible.sync="visible.import" v-if="power.import" width="1024px" center
			:close-on-click-modal="false">
			<el-form @submit.native.prevent label-width="140px">
				<el-form-item label="选择Excel">
                    <el-upload ref="uploadExcel" class="uploadExcel" :action="'api/Personnal/Vehicle/SaveImportExcel?Sign=' + data.sign"
                        :on-success="handleUploadExcelSuccess" :on-change="handleUploadExcelChange"
                        :on-remove="handleUploadExcelRemove" accept=".xls,.xlsx" :multiple="false" :limit="1"
                        :auto-upload="false">
                        <el-button slot="trigger" size="large" type="primary" v-if="uploadsize==0">选择Excel文档</el-button>
                        <div slot="tip" class="el-upload__tip" v-if="uploadsize==0">仅支持xls/xlsx文档</div>
                    </el-upload>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="doSaveImport">保存数据</el-button>
				<el-button @click="visible.import = false">取 消</el-button>
			</span>
		</el-dialog>-->

		<el-dialog title="信息变更" :visible.sync="visible.changeInfo" v-if="power.changeinfo" width="1024" center
			:close-on-click-modal="false">
			<el-form @submit.native.prevent label-width="140px">
				<el-row>
					<el-col :span="12">
						<el-form-item label="车辆编号">
							{{data.info.code}}
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="车牌号">
							{{data.info.carNo}}
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="12">
						<el-form-item label="车检有效期">
							<el-date-picker v-model="data.info.checkDate" size="large"></el-date-picker>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="审批有效期">
							{{data.info.validDate}}
						</el-form-item>
					</el-col>
				</el-row>
				<el-form-item>
					<el-checkbox v-model="data.info.isNormal" size="large">刷人卡</el-checkbox>
				</el-form-item>
				<el-form-item label="司机列表">
					<el-button icon="if-lcon-yuangongdaoru" @click="toSelectDrivers">添加司机</el-button>
				</el-form-item>
				<el-table ref="drivers" :data="data.info.drivers" border class="table" row-key="id"
					highlight-current-row>
					<el-table-column prop="code" label="工号" width="140">
					</el-table-column>
					<el-table-column prop="name" label="姓名" width="120">
					</el-table-column>
					<el-table-column prop="deptName" label="单位" show-overflow-tooltip>
					</el-table-column>
					<el-table-column prop="validDate" label="有效期" width="150">
					</el-table-column>
					<el-table-column prop="opt" label="操作" width="130">
						<template slot-scope="scope">
							<el-button icon="el-icon-delete" @click="doRemoveDriver(scope.$index)">移除</el-button>
						</template>
					</el-table-column>
				</el-table>
				<el-form-item label="车辆图片:">
					<div style="height:200px;width:100%;">
						<el-row>
							<el-col :span="8">
								<img :src="data.image.img"
									style="height:200px;width:100%;object-fit:contain;" />
							</el-col>
							<el-col :span="7">
								<el-button type="primary" @click="loadLocationImage"
									style="width:200px;margin:2px 2px 2px 10px;">本地上传
								</el-button>
								<el-button type="primary" @click="toCropper"
									style="width:200px;margin:2px 2px 2px 10px;">图片裁剪
								</el-button>
							</el-col>
						</el-row>
					</div>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="doChangeInfo">保存数据</el-button>
				<el-button @click="visible.changeInfo = false">取 消</el-button>
			</span>
		</el-dialog>

		<el-dialog title="司机选择" :visible.sync="visible.selectEmp" width="1024px" center :close-on-click-modal="false">
			<el-input v-model="data.search.filterselempstr" @change="searchSelectEmpoyee" size="large"
				style="width:500px;" placeholder="请刷入单位名称/工号/姓名/身份证">
				<el-button slot="append" type="primary" icon="if-lcon-duqushenfenzheng" @click="readFromIdCardReader">
				</el-button>
			</el-input>
			<el-button class="ml10" type="primary" icon="el-icon-search" row-key="id" @click="searchSelectEmpoyee">搜索
			</el-button>
			<el-table ref="selectEmps" class="table" border :data="data.selectEmployees" height="400"
				@selection-change="selectEmpHandleSelectionChange" @cell-click="selectEmpHandleCellClick">
				<el-table-column type="selection"></el-table-column>
				<el-table-column prop="code" label="工号" width="140"></el-table-column>
				<el-table-column prop="name" label="姓名" width="120"></el-table-column>
				<el-table-column prop="deptName" label="单位" show-overflow-tooltip></el-table-column>
				<el-table-column prop="idno" label="身份证" width="150"></el-table-column>
				<el-table-column prop="validDate" label="有效期" width="160"></el-table-column>
			</el-table>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="doSelectDrivers">确认选择</el-button>
				<el-button @click="visible.selectEmp = false">取 消</el-button>
			</span>
		</el-dialog>

		<el-dialog title="权限变更" :visible.sync="visible.changeRight" v-if="power.changeright" width="1024px" center
			:close-on-click-modal="false">
			<el-form @submit.native.prevent label-width="140px">
				<el-form-item label="授权类型" v-if="data.authorize.type != -1">
					<el-radio-group v-model="data.authorize.type">
						<el-radio-button :label="1">加权</el-radio-button>
						<el-radio-button :label="0">消权</el-radio-button>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="权限明细">
					<el-checkbox-group v-model="data.authorize.powers" size="mini">
						<el-checkbox-button v-for="power in data.authorizeGroups" :label="String(power.id)"
							:key="power.id">{{power.name}}</el-checkbox-button>
					</el-checkbox-group>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="doChangeRight">保存数据</el-button>
				<el-button @click="visible.changeRight = false">取 消</el-button>
			</span>
		</el-dialog>

		<takeImage ref="takeImage" @toOk="saveImage" :autoCropWidth="400" :autoCropHeight="300"></takeImage>
	</div>
</template>

<script>
	import takeImage from '../usercontrol/TakeImage.vue'
	export default {
		name: 'vehbusiness',
		data() {
			return {
				data: {
					sign: '',
					depts: [],
					total: 500,
					size: 10,
					page: 1,
					rows: [],
					curDeptId: '0',
					containSubVehicle: true,
					selections: [],
					selectEmployees: [],
					selectEmpSelections: [],
					uploadsize: 0,
					curVehId: 0,
					curEmpId: 0,
					search: {
						filterdeptstr: '',
						filterstr: '',
						filterselempstr: ''
					},
					info: {
						id: 0,
						code: '',
						carNo: '',
						deptName: '',
						checkDate: '',
						validDate: '-',
						drivers: [],
						isNormal: false
					},
					authorize: {
						type: 1,
						vehIds: [],
						powers: []
					},
					image: {
						img: '',
						//0 - 拍照，   1 - 本地，   2 - 脸谱
						imgType: 0
					},
					authorizeGroups: []
				},
				visible: {
					loading: false,
					import: false,
					changeRight: false,
					changeInfo: false,
					selectEmp: false
				},
				power: {
					pageId: 43,
					search: false,
					import: false,
					changeright: false,
					changeinfo: false,
					cancel: false
				}
			}
		},
		methods: {
			readFromIdCardReader() {
				let ths = this;
				ths.dev.gethsidcardreader(ths, 'data.search.filterselempstr', 'visible.loading', v => {
					ths.search(true);
				});
			},
			search(change) {
				let ths = this;
				ths.visible.loading = false;
				if (change) {
					ths.data.page = 1;
				}
				window.ax.get('api/personnal/vehicle/pagerlist?deptid=' + ths.data.curDeptId + '&pagesize=' + ths.data.size +
					'&currentpage=' + ths.data.page + '&sign=' + window.$gloable.userinfo.sign + '&hascard=' + ths.data.search.hasCard +
					'&emptype=' + ths.data.search.empType + '&filterStr=' + ths.data.search.filterstr +
					'&containdown=' + (ths.data.containSubVehicle ? true : false)).then(rsp => {
					let data = rsp.data;
					if (data.code == 1) {
						data = data.data;
						let len = data.datas.length;
						let total = data.totalRecord;
						ths.data.rows = data.datas;
						ths.data.total = total;
						if (len == 0 && total > 0) {
							ths.data.page = Math.ceil(total / ths.data.size);
							ths.search();
						}
					} else {
						ths.$message.error(data.message);
					}
					ths.visible.loading = false;
				}).catch(err => {
					ths.$message.error('执行脚本出错，请联系管理员');
					ths.visible.loading = false;
				});
			},
			searchSelectEmpoyee() {
				let ths = this;
				ths.visible.loading = true;
				window.ax.get('api/personnal/employee/list?sign=' + window.$gloable.userinfo.sign +
					'&filterStr=' + ths.data.search.filterselempstr).then(rsp => {
					let data = rsp.data;
					if (data.code == 1) {
						ths.data.selectEmployees = data.data;
					} else {
						ths.$message.error(data.message);
					}
					ths.visible.loading = false;
				}).catch(err => {
					ths.$message.error('执行脚本出错，请联系管理员');
					ths.visible.loading = false;
				});
			},
			handleSelectionChange(selections) {
				this.data.selections = selections;
			},
			handleCellClick(row, column, cell, event) {
				if (column.property != 'opt') {
					this.$refs.table.toggleRowSelection(row, this.data.selections.indexOf(row) == -1);
				}
			},
			tableCurrentChange(row) {
				this.data.curVehId = row.id;
			},
			selectEmpHandleSelectionChange(selections) {
				this.data.selectEmpSelections = selections;
			},
			selectEmpHandleCellClick(row, column, cell, event) {
				if (column.property != 'opt') {
					this.$refs.selectEmps.toggleRowSelection(row, this.data.selectEmpSelections.indexOf(row) == -1);
				}
			},
			handleSizeChange(size) {
				this.data.selections.splice(0, this.data.selections.length);
				this.data.size = size;
				this.data.page = 1;
				this.search();
			},
			handleCurrentPageChange(current) {
				this.data.selections.splice(0, this.data.selections.length);
				this.data.page = current;
				this.search();
			},
			changeContainSubVehicle() {
				this.search(true);
			},
			filterDept() {
				this.data.search.filterdeptstr = this.data.search.filterdeptstr.toLowerCase();
				this.$refs.depts.filter(this.data.search.filterdeptstr);
			},
			handleDeptNodeClick(data, node, target) {
				let ths = this;
				if (ths.data.curDeptId != data.id) {
					ths.data.curDeptId = data.id;
					ths.data.search.filterstr = '';
					ths.search(true);
				}
			},
			handleTreeFilter(value, data, node) {
				if (!value) {
					return true;
				} else {
					return data.label && data.label.toLowerCase().indexOf(value) != -1;
				}
			},
			toSelectDrivers() {
				let ths = this;
				ths.visible.selectEmp = true;
			},
			doSelectDrivers() {
				let ths = this;
				for (let e of ths.data.selectEmpSelections) {
					let exists = true;
					for (let s of ths.data.info.drivers) {
						if (s.id == e.id) {
							exists = false;
							break;
						}
					}
					if (exists) {
						ths.data.info.drivers.push(e);
					}
				}
				ths.data.search.filterselempstr = '';
				ths.data.selectEmployees.splice(0, ths.data.selectEmployees.length);
				ths.data.selectEmpSelections.splice(0, ths.data.selectEmpSelections.length);
				ths.visible.selectEmp = false;
			},
			doRemoveDriver(idx) {
				this.data.info.drivers.splice(idx, 1);
			},
			/*toImport() {
				let ths = this;
				ths.data.imports = [];
				ths.visible.import = true;
			},
			handleUploadExcelSuccess(response, file, fileLilst) {debugger
                let vue = this;
			},
			handleUploadExcelChange(file, fileList) {
                this.uploadsize = fileList.length;
			},
			handleUploadExcelRemove(file, fileList) {
                --this.uploadsize;
			},
			doImport() {
				
			},*/
			toChangeInfo() {
				let ths = this;
				ths.visible.loading = true;
				ths.data.curVehId = ths.data.selections[0].id;
				window.ax.get('api/personnal/vehicle/info?id=' + ths.data.curVehId + '&sign=' + window.$gloable.userinfo.sign, {})
					.then(rsp => {
						let data = rsp.data;
						if (data.code == 1) {
							data = data.data;
							let veh = data.veh;
							let emps = data.emps;
							ths.data.info.code = veh.code;
							ths.data.info.carNo = veh.carNo;
							ths.data.info.checkDate = veh.checkDate;
							ths.data.info.validDate = veh.validDate;
							ths.data.info.isNormal = veh.isNormal;
							ths.data.info.drivers = emps;
							ths.data.image.img = '/image/carpic/' + veh.carNo + '.jpg';
							ths.visible.changeInfo = true;
						} else {
							ths.$message.error(data.message);
						}
						ths.visible.loading = false;
					}).catch(ex => {
						ths.$message.error('执行脚本出错，请联系管理员');
						ths.visible.loading = false;
					});
			},
			doChangeInfo() {
				let ths = this;
				let drivers = ths.data.info.drivers;
				var eids = [];
				for (let e of drivers) {
					eids.push(e.id);
				}
				let opt = {
					sign: window.$gloable.userinfo.sign,
					id: ths.data.curVehId,
					checkDate: ths.data.info.checkDate,
					isHeader: !ths.data.info.isNormal,
					drivers: eids,
					image: ths.data.image.img
				};
				window.ax.post('api/personnal/vehicle/saveInfo', opt)
					.then(rsp => {
						let data = rsp.data;
						if (data.code == 1) {
							ths.visible.changeInfo = false;
							ths.$message.success(data.message);
						} else {
							ths.$message.error(data.message);
						}
						ths.visible.loading = false;
					}).catch(ex => {
						ths.$message.error('执行脚本出错，请联系管理员');
						ths.visible.loading = false;
					});
				ths.visible.loading = true;
			},
			toChangeRight() {
				let ths = this;
				ths.visible.loading = true;
				ths.data.authorize.powers = [];
				if (ths.data.selections.length == 1) {
					let inf = ths.data.selections[0];
					let id = inf.id;
					ths.data.authorize.vehIds = [id];
					ths.data.info.id = id;
					window.ax.get('api/personnal/vehicle/getRight?id=' + id + '&sign=' + window.$gloable.userinfo.sign, {})
						.then(rsp => {
							let data = rsp.data;
							if (data.code == 1) {
								ths.data.authorize.type = 1;
								ths.data.authorize.powers = data.data.groups;
								ths.visible.changeRight = true;
							} else {
								ths.$message.error(data.message);
							}
							ths.visible.loading = false;
						}).catch(ex => {
							ths.$message.error('执行脚本出错，请联系管理员');
							ths.visible.loading = false;
						});
				} else {
					ths.data.authorize.type = 1;
					ths.data.authorize.vehIds.splice(0, ths.data.authorize.vehIds.length);
					for (let i = 0; i < ths.data.selections.length; i++) {
						ths.data.authorize.vehIds.push(ths.data.selections[i].id);
					}
					ths.visible.changeRight = true;
					ths.visible.loading = false;
				}
			},
			doChangeRight() {
				let ths = this;
				ths.visible.loading = true;
				let opt = {
					Sign: window.$gloable.userinfo.sign,
					VehIds: ths.data.authorize.vehIds,
					Type: ths.data.authorize.type,
					Authorizes: ths.data.authorize.powers
				};
				window.ax.post('api/personnal/vehicle/saveauthorize', opt).then(rsp => {
					let data = rsp.data;
					if (data.code == 1) {
						ths.$message.success(data.message);
						ths.visible.changeRight = false;
					} else {
						ths.$message.error(data.message);
					}
					ths.visible.loading = false;
				}).catch(err => {
					console.log(err);
					ths.visible.loading = false;
				});
			},
			toCancel() {
				let ths = this;
				let inf = ths.data.selections[0];
				let id = inf.id;
				ths.visible.loading = true;
				ths.$confirm('请确认是否注销该车辆信息（' + inf.deptName + '-' + inf.licensePlate + '），注销前，请确认移出该车辆所有司机信息。', '提示').then(
					o => {
						ths.doCancel(id);
						ths.visible.loading = false;
					}
				).catch(o => {
					ths.visible.loading = false;
				});
			},
			doCancel(id) {
				let ths = this;
				let opt = {
					Sign: window.$gloable.userinfo.sign,
					id: id
				};
				window.ax.post('api/personnal/vehicle/cancelVehicle', opt).then(rsp => {
					let data = rsp.data;
					if (data.code == 1) {
						ths.$message.success(data.message);
						ths.search();
					} else {
						ths.$message.error(data.message);
					}
					ths.visible.loading = false;
				}).catch(ex => {
					ths.$message.error('执行脚本出错，请联系管理员');
					ths.visible.loading = false;
				});
			},
			blobToBase64(blob) {
				return new Promise((resolve, reject) => {
					const reader = new FileReader();
					reader.onload = e => {
						resolve(e.target.result);
					};
					reader.onerror = () => {
						reject(new Error('文件流异常'));
					}
					reader.readAsDataURL(blob);
				});
			},
			loadLocationImage() {
				this.$refs.takeImage.init();
			},
			saveImage(img, type) {
				let ths = this;
				if (type == 'camera') {
					ths.data.image.imgType = 0;
				} else if (type == 'location') {
					ths.data.image.imgType = 1;
				}
				ths.blobToBase64(img).then(r => {
					ths.data.image.img = r;
					ths.data.image.imgType = 2;
				});
			},
			toCropper() {
				let ths = this;
				this.$refs.takeImage.init();
				this.$refs.takeImage.setCurrentImage(ths.data.image.img);
			}
		},
		created() {
			let ths = this;
			ths.data.sign = window.$gloable.userinfo.sign;
			ths.baseJS.initPower(ths.power);
			ths.api.loadDepartmentTree(ths, 'data.depts', 'visible.loading');
			ths.api.loadVehAuthorizeGroup(ths, 'data.authorizeGroups', 'visible.loading', 1);
		},
		mounted() {},
		components: {
			takeImage
		}
	}
</script>

<style>
	.ml10 {
		margin-left: 10px;
	}

	.handle-input {
		width: 200px;
		display: inline-block;
	}

	.handle-box {
		margin-bottom: 20px;
	}

	.left {
		float: left;
		margin-left: 10;
	}

	.right {
		float: right;
		margin-right: 10;
	}

	.handle-select {
		width: 120px;
	}

	.table {
		width: 100%;
		font-size: 14px;
	}

	.el-tree-node__content {
		height: 36px !important;
	}

	.dialog-footer {
		height: 30px;
	}

	.vehbusiness .uploadExcel {
		height: 35px;
		overflow: hidden;
		width: 340px;
		border: 1px solid #cccccc;
		padding: 5px;
		float: left;
	}

	.vehbusiness .uploadExcel .el-upload--text {
		width: 100px;
		height: 35px;
		line-height: 35px;
		border: none;
		float: left;
	}

	.vehbusiness .uploadExcel .el-upload__tip {
		margin-top: 0px;
		width: 100px;
		height: 35px;
		line-height: 35px;
		float: left;
	}

	.vehbusiness .uploadExcel .el-upload-list--text {
		width: 200px;
		height: 35px;
		line-height: 35px;
		float: left;
	}

	.vehbusiness .uploadExcel .el-upload-list--text li {
		margin-top: 4px;
	}
</style>
